import { TableType } from '@/components/Filters/filter-constants';

export const COLUMN_NAMES = {
  ACTIONS: 'actions',
  ADDED_BY: 'added_by',
  CREATED_AT: 'created_at',
  CREATOR: 'creator',
  DISPLAY_NAME: 'display_name',
  FILE_COUNT: 'file_count',
  SELECT: 'select',
  SIZE: 'size',
  STATUS: 'status',
  TAGS: 'tags',
  TOP_LANGUAGE: 'top_language',
  UPDATED_AT: 'updated_at',
} as const;

export function getColumnTooltips(tableType: TableType) {
  const tooltips = {
    [TableType.CODEBASE]: {
      [COLUMN_NAMES.TOP_LANGUAGE]: 'The most commonly used programming language in the codebase',
      [COLUMN_NAMES.FILE_COUNT]: 'The number of files you have connected from each codebase.',
      [COLUMN_NAMES.SIZE]: 'File size of the codebase.',
      [COLUMN_NAMES.CREATED_AT]: 'Date this codebase was connected to your organization.',
      [COLUMN_NAMES.UPDATED_AT]: 'Date this codebase was updated manually or automatically.',
      [COLUMN_NAMES.ADDED_BY]: 'The user who added the codebase',
      [COLUMN_NAMES.STATUS]: 'Status of this codebase in your organization.',
      [COLUMN_NAMES.TAGS]: 'Create tags to organize sources and documents.',
    },
    [TableType.PDF]: {
      [COLUMN_NAMES.SIZE]: 'File size of the PDF.',
      [COLUMN_NAMES.CREATED_AT]: 'Date this PDF was connected to your organization.',
      [COLUMN_NAMES.UPDATED_AT]: 'Date this PDF was updated manually or automatically.',
      [COLUMN_NAMES.ADDED_BY]: 'The user who added the PDF',
      [COLUMN_NAMES.STATUS]: 'Status of this PDF in your organization.',
      [COLUMN_NAMES.TAGS]: 'Create tags to organize sources and documents.',
    },
    [TableType.PAGE]: {
      [COLUMN_NAMES.CREATED_AT]: 'Date this Page was created in your organization.',
      [COLUMN_NAMES.UPDATED_AT]: 'Date this Page was last edited by someone in your organization.',
      [COLUMN_NAMES.TAGS]: 'Create tags to organize sources and documents.',
    },
    [TableType.TEAM]: {
      [COLUMN_NAMES.CREATED_AT]: 'Date this team was created in your organization.',
      [COLUMN_NAMES.UPDATED_AT]: 'Date this team was last edited by someone in your organization.',
      // TODO: Teams: Add tooltips for team columns
    },
  };

  return tooltips[tableType] ?? {};
}
